import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/Service/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

  constructor(
    private route: Router,
    private service: AuthService,
    private notification: ToastrService
  ) { 
    
  }

  email = '';
  responseData: any;
  load = false;

  ngOnInit(): void {
  }


  VerifyEmail = new FormGroup({
    email: new FormControl(" ", Validators.required)
  })


  ValidateEmail(){
    // this.load = true;
    if(this.VerifyEmail.valid){
      let payload = this.VerifyEmail.value.email;
      this.service.forgetPassword(payload).subscribe((res: any) => {        
        if(res.status == 200){
          this.responseData = res;
          console.log(this.responseData);
          Swal.fire('Check mail', 'success')
        } else {
          Swal.fire({
            icon: 'error',
            title: `${res.message}`,
            footer: 'Kindly use your correct details. Use the chatbot for Self Services'
          });
          this.load = false;
        }
      }), (error: { message: string | undefined; }) => {
        this.notification.error(error.message)
        this.load = false;
      }
    }

  }


  navigatenewUser(){
    this.route.navigate(['/signup'])
  }



}
